import { Card, Col, Row } from "react-bootstrap";
import { IInstructionDetails } from "../../../api/Instruction";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { getIconForType } from "../../../leap-components/icons/LeapIcons";

interface InstructionHeaderProps {
  instruction: IInstructionDetails;
}

const InstructionHeader = ({ instruction }: InstructionHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>{getIconForType("EPA Initiated Correspondence")}</td>
                  <td>
                    <h2>
                      {`Licensee Return Instructions: ${instruction.reference}`}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={instruction.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={instruction.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={instruction.regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default InstructionHeader;
